import { useAuth } from '../contexts/AuthContext';

export const useAuthHeaders = () => {
  const { user } = useAuth();

  const getAuthHeaders = async () => {
    if (!user?.userPool) {
      console.log('No userPool available');
      return {};
    }
    
    const cognitoUser = user.userPool.getCurrentUser();
    if (!cognitoUser) {
      console.log('No current user');
      return {};
    }
    
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          console.error('Session error:', err);
          resolve({});
          return;
        }
        
        if (!session || !session.isValid()) {
          console.log('Invalid session');
          resolve({});
          return;
        }
        
        const token = session.getIdToken().getJwtToken();
        console.log('Got token:', token.substring(0, 20) + '...');
        resolve({
          'Authorization': token
        });
      });
    });
  };

  return { getAuthHeaders };
};
